import { SxProps, Theme } from '@mui/material';

export const dataGridTableStyles: SxProps<Theme> = {
  border: 0,

  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-columnSeparator, & .MuiDataGrid-columnHeaderSeparator': {
    visibility: 'hidden !important',
  },
  '& .MuiDataGrid-footerContainer': {
    height: 38,
    minHeight: 38,
    maxHeight: 38,
  },
  '& .MuiDataGrid-cell': {
    paddingLeft: 0,
    paddingRight: 0,
  },
};

export const focusedCellsStyles: SxProps<Theme> = {
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none !important',
    },
};

export const stickyColumnsStyles =
  (firstColumnId: string): SxProps<Theme> =>
  (theme) => ({
    [`& .MuiDataGrid-cell[data-field="actions"]`]: {
      position: 'sticky',
      right: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.paper,
      borderLeft: `1px solid ${theme.palette.divider}`,
      '&::before': {
        display: 'none',
      },
    },
    [`& .MuiDataGrid-cell[data-field="${firstColumnId}"]`]: {
      position: 'sticky',
      left: 0,
      zIndex: 10,
      backgroundColor: theme.palette.background.paper,
      borderRight: `1px solid ${theme.palette.divider}`,
      '&::before': { display: 'none' },
    },
  });

export const editingCellsStyles =
  (firstColumnId: string): SxProps<Theme> =>
  (theme) => ({
    '& .MuiDataGrid-cell--editing': {
      padding: '0 !important',
      boxShadow: 'none !important',
    },

    [`& .MuiDataGrid-cell--editing:not([data-field="${firstColumnId}"]):not([data-field="actions"]) .MuiDataGrid-editInputCell`]:
      {
        height: '100%',
        padding: 0,
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        boxSizing: 'border-box',
      },

    '& .MuiDataGrid-cell--editing .MuiDataGrid-editInputCell .MuiInputBase-input': {
      padding: '0 8px !important',
      height: '100%',
      boxSizing: 'border-box',
    },
  });
